import { DeviceIcon, FavouriteIcon, NavigationIcon } from '@tymbe/ui-icons';
import { DropDownMenuOption } from '../ShiftDetail/DropDownMenu';
import Options from '../Options';

interface ShiftDetailHeaderProps {
  startDate: string;
  timeSpan: string;
  showHistory: boolean;
  toggleShowHistory: () => void;
  onClose: () => void;
  menuOptions: DropDownMenuOption[];
}

export const ShiftDetailHeader = ({
  startDate,
  timeSpan,
  showHistory,
  toggleShowHistory,
  onClose,
  menuOptions,
}: ShiftDetailHeaderProps) => {
  return (
    <div className="flex align-middle text-heading-4-xl text-secondary-600">
      {showHistory ? (
        <div className="flex justify-start items-center">
          <NavigationIcon
            name="west"
            onClick={toggleShowHistory}
            className="mr-2 size-5 cursor-pointer"
          />
          Historie
          <FavouriteIcon
            name="close"
            className="size-5 text-secondary-400 absolute right-2 top-2 cursor-pointer"
            onClick={onClose}
          />
        </div>
      ) : (
        <div className="flex flex-col">
          <FavouriteIcon
            name="close"
            className="size-5 text-secondary-400 absolute right-2 top-2 cursor-pointer"
            onClick={onClose}
          />
          <div className="flex">
            Detail směny
            <Options
              menuOptions={menuOptions}
              className="text-secondary-500 ml-2"
            />
          </div>
          <div className="flex text-caption-md gap-2 mt-2">
            <div className="flex items-center border-secondary-transparent-10 border-[1px] px-2 py-1 gap-2 rounded-md">
              <FavouriteIcon name="calendar_today" className='w-[16px] h-[16px]' />
              {startDate}
            </div>
            <div className="flex items-center border-secondary-transparent-10 border-[1px] px-2 py-1 gap-2 rounded-md">
              <DeviceIcon name="access_time" className='w-[16px] h-[16px]' />
              {timeSpan}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
